import React, { useContext, useEffect } from 'react';
import AuthContext from '../../context/auth/authContext';

// S3-05: This is a public portfolio/demo app — open self-service account
// creation is not an intentional feature here. Rather than present a form
// that implies anyone can sign up (and then fail with a 403 from the
// backend, which now disables registration by default), this page shows a
// clear, upfront message pointing visitors to the provided demo login
// instead. The message intentionally matches the backend's
// disabled-registration posture (see routes/users.js
// ALLOW_PUBLIC_REGISTRATION) so the UI never implies an open sign-up system
// that the API would then reject.
const Register = (props) => {
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push('/')
    }
    // eslint-disable-next-line
  }, [isAuthenticated, props.history]);

  return (
    <div className='form-container'>
      <div className="alert alert-warning" role="alert">
        <strong>Demo only.</strong> Do not enter real personal health information.
      </div>
      <h1>
        Account <span className="text-primary">Register</span>
      </h1>
      <div className="alert alert-info" role="alert">
        Public registration is disabled for this portfolio demo. Please use the provided demo login.
      </div>
    </div>
  );
};

export default Register
